// extracted by mini-css-extract-plugin
export default {"spinnerButton":"federalProformaProcesses_spinnerButton__UU3LR","gridContainer":"federalProformaProcesses_gridContainer__TwrvW","redFlag":"federalProformaProcesses_redFlag__Kctqs"};